import { createFileRoute } from "@tanstack/react-router";

import AcceptInvitePage from "@/features/auth/pages/accept-invite";
import { AuthProvider } from "@/providers/auth.provider";

interface AcceptInviteSearchParams {
  token?: string;
}

export const Route = createFileRoute("/(auth)/accept-invite")({
  component: () => (
    <AuthProvider>
      <main role="main" aria-label="Accept invite page" className="min-h-screen w-full">
        <AcceptInvitePage />
      </main>
    </AuthProvider>
  ),
  validateSearch: (search: Record<string, unknown>): AcceptInviteSearchParams => ({
    token: search.token as string | undefined,
  }),
});
